import { RewardTypes } from "state/types/UserTypes";
import { InitialState } from "state/InitialState";
import { Utils } from "utils/Utils";

// ----------------------------------------------------------------------

export const SubscribersActions = {};

// ACTIONS PURAS
// ----------------------------------------------------------------------

SubscribersActions.sync = () => ({
  subscribers: {
    lastSync: Date.now()
  },
  type: RewardTypes.sync
});

SubscribersActions.set = (subscribers) => ({
  subscribers: {
    data: subscribers,
    lastSync: Date.now()
  },
  type: RewardTypes.set
});

SubscribersActions.unset = () => ({
  subscribers: InitialState.createSyncObject(),
  type: RewardTypes.unset
});

SubscribersActions.success = (success) => ({
  subscribers: {
    success: (success === true)
  },
  type: RewardTypes.success
});

SubscribersActions.pending = (pending) => ({
  subscribers: {
    pending: (pending === true)
  },
  type: RewardTypes.pending
});

SubscribersActions.error = (error) => ({
  subscribers: {
    error
  },
  type: RewardTypes.error
});
